import {
  TypingQuizAction,
  TypingQuizContainer,
  TypingQuizItemSkip,
} from './TypingQuiz.styles';
import Button from 'components/Button';
import Paragraph from 'components/Typography/Paragraph';
import ContentWrapper from 'components/ContentWrapper';
import { TypingQuizProps } from './TypingQuiz.type';
import { useState } from 'react';
import ArrowsRight from 'Icons/ArrowsRight';
import Modal from 'components/Modal';
import TypingQuizPopup from '../QcmQuizPopup';
import Correct from 'assets/icons/Correct.png';
import Wrong from 'assets/icons/Wrong.png';
import Input from 'components/Input';
import { useTranslation } from 'react-i18next';

const TypingQuiz = ({
  avatar,
  question,
  correctAnswer,
  onSkip,
  onCorrect,
  onWrong,
}: TypingQuizProps): JSX.Element => {
  const { t } = useTranslation();
  const [answerValue, setAnswerValue] = useState<string>('');
  const [disabledBtn, setDisbaledBtn] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [quizState, setQuizState] = useState<boolean>(false);

  // handle Change checkd items
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAnswerValue(e.target.value);
    if (e.target.value) {
      setDisbaledBtn(false);
    } else {
      setDisbaledBtn(true);
    }
  };

  const onClose = () => {
    setShowModal(false);
  };

  const checkCorrectAnswer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (answerValue.toLowerCase() === correctAnswer.toLowerCase()) {
      setQuizState(true);
      setShowModal(true);
    }
    if (answerValue.toLowerCase() !== correctAnswer.toLowerCase()) {
      setQuizState(false);
      setShowModal(true);
    }
  };

  return (
    <ContentWrapper avatar={avatar} hasSpeechBox={true} text={question}>
      <TypingQuizContainer data-testid="TypingQuiz">
        <Input
          placeholder="Enter your response here"
          value={answerValue}
          onChange={handleChange}
        />
        <TypingQuizAction>
          <Button
            rotation="-3.21deg"
            shadowColor="black"
            width="15rem"
            onClick={(e) => checkCorrectAnswer(e)}
            disabled={disabledBtn}
          >
            {t('continue')}
          </Button>
          <TypingQuizItemSkip onClick={onSkip}>
            <Paragraph> {t('skip')}</Paragraph>
            <ArrowsRight />
          </TypingQuizItemSkip>
        </TypingQuizAction>
      </TypingQuizContainer>
      <Modal isOpen={showModal} closeModal={onClose}>
        <TypingQuizPopup
          title={quizState ? t('goodAnswers') : t('wrongAnswers')}
          status={quizState ? 'correct' : 'wrong'}
          image={quizState ? Correct : Wrong}
          onClose={onClose}
          onButtonClick={quizState ? onCorrect : onClose}
        />
      </Modal>
    </ContentWrapper>
  );
};

export default TypingQuiz;
